let ctx;
let originalImage = false;

const brushDisplay = document.createElement('canvas');
const brushDisplayCtx = brushDisplay.getContext('2d');
document.body.appendChild(brushDisplay);
brushDisplay.style.display = 'none';

let brushCtx;

// const brushCanvas = document.createElement('canvas');
// const brushCtx = brushCanvas.getContext('2d');
// document.body.appendChild(brushCanvas);
// brushCanvas.style.display = 'block';
// window.brushCanvas = brushCanvas;

function getCanvasRelativePosition(e, canvas) {
  const rect = canvas.getBoundingClientRect();
  return {
    x: ((e.clientX - rect.left) / rect.width) * canvas.width,
    y: ((e.clientY - rect.top) / rect.height) * canvas.height,
  };
}

function getAbsolutePosition(x, y, canvas) {
  const rect = canvas.getBoundingClientRect();
  // console.log('getAbsolutePosition', { rect });
  return {
    x: ((x + rect.left) * rect.width) / canvas.width,
    y: ((y + rect.top) * rect.height) / canvas.height,
  };
}

function lerp(a, b, t) {
  return a + (b - a) * t;
}

function setupLine(x, y, targetX, targetY) {
  const deltaX = targetX - x;
  const deltaY = targetY - y;
  const deltaRow = Math.abs(deltaX);
  const deltaCol = Math.abs(deltaY);
  const counter = Math.max(deltaCol, deltaRow);
  const axis = counter === deltaCol ? 1 : 0;
  return {
    position: [x, y],
    delta: [deltaX, deltaY],
    deltaPerp: [deltaRow, deltaCol],
    inc: [Math.sign(deltaX), Math.sign(deltaY)],
    accum: Math.floor(counter / 2),
    counter,
    endPnt: counter,
    axis,
    u: 0,
  };
}

function advanceLine(line) {
  --line.counter;
  line.u = 1 - line.counter / line.endPnt;
  if (line.counter <= 0) {
    return false;
  }
  const axis = line.axis;
  const perp = 1 - axis;
  line.accum += line.deltaPerp[perp];
  if (line.accum >= line.endPnt) {
    line.accum -= line.endPnt;
    line.position[perp] += line.inc[perp];
  }
  line.position[axis] += line.inc[axis];
  return true;
}

let lastX;
let lastY;
let lastForce;
let alpha = 0.5;

let manipulationCtx;

let featherGradient;

function feather(ctx) {
  // feather the brush
  ctx.save();
  ctx.fillStyle = featherGradient;
  ctx.globalCompositeOperation = 'destination-out';
  const { width, height } = ctx.canvas;
  ctx.translate(width / 2, height / 2);
  ctx.fillRect(-width / 2, -height / 2, width, height);
  ctx.restore();
}

function updateBrush(x, y) {
  // console.log('update brush ', x, y);
  const absPos = getAbsolutePosition(x, y, ctx.canvas);
  document.getElementById(
    'sample'
  ).style = `left: ${absPos.x}px; top: ${absPos.y}px;`;
  // console.log({ absPos });
  let width = brushCtx.canvas.width;
  let height = brushCtx.canvas.height;
  let srcX = x - width / 2;
  let srcY = y - height / 2;
  // draw it in the middle of the brush
  let dstX = (brushCtx.canvas.width - width) / 2;
  let dstY = (brushCtx.canvas.height - height) / 2;

  // clear the brush canvas
  brushCtx.clearRect(0, 0, brushCtx.canvas.width, brushCtx.canvas.height);

  // clip the rectangle to be inside
  if (srcX < 0) {
    width += srcX;
    dstX -= srcX;
    srcX = 0;
  }
  const overX = srcX + width - ctx.canvas.width;
  if (overX > 0) {
    width -= overX;
  }

  if (srcY < 0) {
    dstY -= srcY;
    height += srcY;
    srcY = 0;
  }
  const overY = srcY + height - ctx.canvas.height;
  if (overY > 0) {
    height -= overY;
  }

  if (width <= 0 || height <= 0) {
    return;
  }

  brushCtx.drawImage(
    ctx.canvas,
    srcX,
    srcY,
    width,
    height,
    dstX,
    dstY,
    width,
    height
  );

  feather(brushCtx);
}

const CloneStamp = {
  MODE_SMUDGE: 'MODE_SMUDGE',
  MODE_PROGRESSIVE: 'MODE_PROGRESSIVE',
  MODE_STAMP: 'MODE_STAMP',

  points: [],
  history: [],
  brushPos: {},
  historyIndex: 0,
  delta: false,
  drawingEnabled: true,
  needsSnapshot: false,
  progressive: false,
  drawing: false,
  shouldClipWithinOriginalImageBounds: true,

  mode: 'MODE_STAMP',

  init(imageObject, opts = {}) {
    opts = {
      shouldClipWithinOriginalImageBounds: true,
      ...opts,
    };

    this.opts = opts;

    ctx = document
      .querySelector(this.opts.drawingCanvasSelector)
      .getContext('2d');

    manipulationCtx = document
      .querySelector(this.opts.manipulationCanvasSelector)
      .getContext('2d');

    brushCtx = document
      .querySelector(this.opts.brushCanvasSelector)
      .getContext('2d');

    this.mousedownFn = this.start.bind(this);
    this.mousemoveFn = this.draw.bind(this);
    this.mouseupFn = this.stop.bind(this);
    this.applyFn = this.apply.bind(this);
    this.undoFn = this.undo.bind(this);
    this.redoFn = this.redo.bind(this);

    window.addEventListener('mousedown', this.mousedownFn);
    window.addEventListener('mousemove', this.mousemoveFn);
    window.addEventListener('mouseup', this.mousemoveFn);
    window.addEventListener('mouseup', this.mouseupFn);
    document
      .querySelector(this.opts.applyBtnSelector)
      .addEventListener('mouseup', this.applyFn);
    document
      .querySelector(this.opts.undoBtnSelector)
      .addEventListener('mouseup', this.undoFn);
    document
      .querySelector(this.opts.redoBtnSelector)
      .addEventListener('mouseup', this.redoFn);
    originalImage = imageObject._element;
    this.render();
    this.onApply = opts.onApply;
    this.updateBrushSettings();

    this.shouldClipWithinOriginalImageBounds =
      opts.shouldClipWithinOriginalImageBounds;

    this.takeSnapshot();

    if (opts.onReady) {
      opts.onReady();
    }
  },
  updateProgressive(progressive) {
    this.progressive = progressive;
  },
  setMode(mode) {
    this.mode = mode;
  },
  _createFeatherGradient(radius, hardness) {
    const innerRadius = Math.min(radius * hardness, radius - 1);
    const gradient = brushCtx.createRadialGradient(
      0,
      0,
      innerRadius,
      0,
      0,
      radius
    );
    gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
    gradient.addColorStop(1, 'rgba(0, 0, 0, 1)');
    return gradient;
  },
  undo(e) {
    e.preventDefault();
    e.stopPropagation();
    this.needsSnapshot = false;
    this.drawing = false;
    const lastState = this.history[this.historyIndex - 1];
    this.historyIndex = Math.max(this.historyIndex - 1, 0);
    const { width, height } = manipulationCtx.canvas;
    manipulationCtx.clearRect(0, 0, width, height);

    const image = new Image();
    image.onload = () => {
      manipulationCtx.globalAlpha = 1;
      manipulationCtx.drawImage(image, 0, 0);
      this.render();
    };
    image.src = lastState;
  },
  redo(e) {
    e.preventDefault();
    e.stopPropagation();
    this.needsSnapshot = false;
    this.drawing = false;
    const nextState = this.history[this.historyIndex + 1];
    this.historyIndex = Math.min(this.historyIndex + 1, this.history.length);
    const { width, height } = manipulationCtx.canvas;
    manipulationCtx.clearRect(0, 0, width, height);

    const image = new Image();
    image.onload = () => {
      manipulationCtx.globalAlpha = 1;
      manipulationCtx.drawImage(image, 0, 0);
      this.render();
    };
    image.src = nextState;
  },
  updateBrushSettings(radius = 16, hardness = 0.5, alpha = 0.5) {
    featherGradient = this._createFeatherGradient(radius, hardness);
    brushCtx.canvas.width = radius * 2;
    brushCtx.canvas.height = radius * 2;
    const ctx = brushDisplayCtx;
    const { width, height } = ctx.canvas;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = `rgba(0, 0, 0, ${alpha})`;
    ctx.fillRect(
      width / 2 - radius,
      height / 2 - radius,
      radius * 2,
      radius * 2
    );
    feather(ctx);
    updateBrush(lastX, lastY);
  },
  stop() {
    this.delta = false;
    if (this.needsSnapshot) {
      this.takeSnapshot();
    }
    this.needsSnapshot = false;
    this.drawing = false;
  },
  takeSnapshot() {
    this.history = this.history.splice(0, this.historyIndex + 1);
    this.history.push(manipulationCtx.canvas.toDataURL());
    this.historyIndex = this.history.length - 1;
  },
  draw(e) {
    // console.log('DRAW!!!');
    // console.log('drawingEnabled', this.drawingEnabled);
    // console.log('drawing', this.drawing);

    if (!this.drawingEnabled) {
      return;
    }
    if (!this.drawing) {
      return;
    }
    const pos = getCanvasRelativePosition(e, ctx.canvas);
    const force = e.force || 1;

    const line = setupLine(lastX, lastY, pos.x, pos.y);
    for (let more = true; more; ) {
      more = advanceLine(line);
      manipulationCtx.globalAlpha = alpha * lerp(lastForce, force, line.u);
      manipulationCtx.drawImage(
        brushCtx.canvas,
        line.position[0] - brushCtx.canvas.width / 2,
        line.position[1] - brushCtx.canvas.height / 2
      );

      if (this.mode === CloneStamp.MODE_SMUDGE) {
        updateBrush(line.position[0], line.position[1]);
      } else if (this.mode === CloneStamp.MODE_PROGRESSIVE) {
        if (!this.delta) {
          this.delta = {
            x: line.position[0] - this.brushPos.x,
            y: line.position[1] - this.brushPos.y,
          };
        }
        this.brushPos = {
          x: line.position[0] - this.delta.x,
          y: line.position[1] - this.delta.y,
        };
        updateBrush(this.brushPos.x, this.brushPos.y);
      }
    }
    lastX = pos.x;
    lastY = pos.y;
    lastForce = force;
    this.needsSnapshot = true;
    this.render();
  },
  disableDrawing() {
    this.drawingEnabled = false;
  },
  enableDrawing() {
    this.drawingEnabled = true;
  },
  clearSelection() {
    this.points = [];
    this.render();
  },
  addSelectionPoint(e) {
    const pos = getCanvasRelativePosition(e, ctx.canvas);
    this.points.push(pos);
    this.render();
  },
  start(e) {
    if (!this.drawingEnabled) {
      return false;
    }
    const pos = getCanvasRelativePosition(e, ctx.canvas);

    lastX = pos.x;
    lastY = pos.y;
    lastForce = e.force || 1;
    this.drawing = true;
  },
  apply() {
    window.removeEventListener('mousedown', this.mousedownFn);
    window.removeEventListener('mousemove', this.mousemoveFn);
    window.removeEventListener('mouseup', this.mouseupFn);
    document
      .querySelector(this.opts.applyBtnSelector)
      .removeEventListener('mouseup', this.applyFn);

    document
      .querySelector(this.opts.undoBtnSelector)
      .removeEventListener('mouseup', this.undoFn);
    document
      .querySelector(this.opts.redoBtnSelector)
      .removeEventListener('mouseup', this.redoFn);

    this.render(false);
    const trimmedCanvas = this._trimCanvas(ctx.canvas);
    const img = trimmedCanvas.toDataURL();
    this.onApply(img);
    this.render();
  },
  setSampleAtMousePosition(e) {
    e.stopPropagation();
    e.preventDefault();
    const pos = getCanvasRelativePosition(e, ctx.canvas);
    lastX = pos.x;
    lastY = pos.y;
    lastForce = e.force || 1;
    this.drawing = true;
    updateBrush(pos.x, pos.y);
    this.brushPos = {
      x: pos.x,
      y: pos.y,
    };
  },
  render(selectionVisible = true) {
    if (!originalImage) {
      return false;
    }

    ctx.clearRect(0, 0, window.canvas.width, window.canvas.height);

    const isSquare = originalImage.height === originalImage.width;
    let imgHeight;
    let imgWidth;

    if (isSquare) {
      const isCanvasSquare = window.canvas.height === window.canvas.width;
      if (isCanvasSquare) {
        imgWidth = window.canvas.width;
        imgHeight = window.canvas.height;
      } else {
        const isCanvasVertical = window.canvas.height > window.canvas.width;

        imgHeight = isCanvasVertical
          ? this._scaleToWidth(
              originalImage.width,
              originalImage.height,
              window.canvas.width
            )
          : window.canvas.height;

        imgWidth = isCanvasVertical
          ? window.canvas.width
          : this._scaleToHeight(
              originalImage.width,
              originalImage.height,
              window.canvas.height
            );
      }
    } else {
      const isVertical = originalImage.height > originalImage.width;

      imgHeight = isVertical
        ? window.canvas.height
        : this._scaleToWidth(
            originalImage.width,
            originalImage.height,
            window.canvas.width
          );
      imgWidth = isVertical
        ? this._scaleToHeight(
            originalImage.width,
            originalImage.height,
            window.canvas.height
          )
        : window.canvas.width;
    }

    ctx.drawImage(
      originalImage,
      window.canvas.width / 2 - imgWidth / 2,
      window.canvas.height / 2 - imgHeight / 2,
      imgWidth,
      imgHeight
    );

    ctx.save();

    this._renderSelection(selectionVisible, this.points);
    if (this.points.length > 0) {
      ctx.clip();
    }

    if (this.shouldClipWithinOriginalImageBounds) {
      ctx.beginPath();
      ctx.lineWidth = '25';
      ctx.strokeStyle = 'green'; // Green path
      const startX = window.canvas.width / 2 - imgWidth / 2;
      const startY = window.canvas.height / 2 - imgHeight / 2;
      // console.log({ startX, startY });
      ctx.moveTo(startX, startY);
      ctx.lineTo(imgWidth, startY);
      ctx.lineTo(imgWidth, startY + imgHeight);
      ctx.lineTo(startX, startY + imgHeight);
      ctx.lineTo(startX, startY);
      ctx.clip();
      ctx.stroke(); // Draw it
    }

    this._renderManipulation();

    ctx.restore();
  },
  _scaleToWidth: function (sourceWidth, sourceHeight, targetWidth) {
    const aspectRatio = sourceHeight / sourceWidth;
    return targetWidth * aspectRatio;
  },
  _scaleToHeight: function (sourceWidth, sourceHeight, targetHeight) {
    const aspectRatio = sourceWidth / sourceHeight;
    return targetHeight * aspectRatio;
  },
  _renderSelection(selectionVisible, points) {
    if (points.length <= 1) {
      return;
    }

    ctx.save();

    if (selectionVisible) {
      ctx.setLineDash([5, 3]);
      ctx.strokeStyle = '#B4D5FE';
      ctx.fillStyle = 'rgba(180,213,254,0.1)';
      ctx.lineWidth = 1;
    } else {
      ctx.strokeStyle = 'rgba(0, 0, 0, 0)';
      ctx.fillStyle = 'rgba(0, 0, 0, 0)';
    }
    ctx.beginPath();
    for (var index = 0; index < points.length; index++) {
      var point = points[index];
      if (index === 0) {
        ctx.moveTo(point.x, point.y);
      } else {
        ctx.lineTo(point.x, point.y);
      }
    }

    // ctx.lineTo(start.x, start.y);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();

    ctx.restore();
  },
  _renderManipulation() {
    ctx.drawImage(manipulationCtx.canvas, 0, 0);
  },
  _trimCanvas(c) {
    var ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null,
      },
      x,
      y;

    // Iterate over every pixel to find the highest
    // and where it ends on every axis ()
    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~(i / 4 / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    // Calculate the height and width of the content
    var trimHeight = bound.bottom - bound.top,
      trimWidth = bound.right - bound.left,
      trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // Return trimmed canvas
    return copy.canvas;
  },
};

window.CloneStamp = CloneStamp;
